var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57890_49185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_57890_49185",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.24298 0 0 2.24298 0 5C0 7.75702 2.24298 10 5 10C7.75702 10 10 7.75702 10 5C10 2.24298 7.75702 0 5 0ZM5 9.28571C2.63687 9.28571 0.714286 7.36314 0.714286 5C0.714286 2.63687 2.63687 0.714286 5 0.714286C7.36314 0.714286 9.28571 2.63687 9.28571 5C9.28571 7.36314 7.36314 9.28571 5 9.28571Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.24298 0 0 2.24298 0 5C0 7.75702 2.24298 10 5 10C7.75702 10 10 7.75702 10 5C10 2.24298 7.75702 0 5 0ZM5 9.28571C2.63687 9.28571 0.714286 7.36314 0.714286 5C0.714286 2.63687 2.63687 0.714286 5 0.714286C7.36314 0.714286 9.28571 2.63687 9.28571 5C9.28571 7.36314 7.36314 9.28571 5 9.28571Z",
    fill: "#E9EDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 -1C1.69069 -1 -1 1.69069 -1 5H1C1 2.79526 2.79526 1 5 1V-1ZM-1 5C-1 8.30931 1.69069 11 5 11V9C2.79526 9 1 7.20474 1 5H-1ZM5 11C8.30931 11 11 8.30931 11 5H9C9 7.20474 7.20474 9 5 9V11ZM11 5C11 1.69069 8.30931 -1 5 -1V1C7.20474 1 9 2.79526 9 5H11ZM5 8.28571C3.18915 8.28571 1.71429 6.81085 1.71429 5H-0.285714C-0.285714 7.91542 2.08458 10.2857 5 10.2857V8.28571ZM1.71429 5C1.71429 3.18915 3.18915 1.71429 5 1.71429V-0.285714C2.08458 -0.285714 -0.285714 2.08458 -0.285714 5H1.71429ZM5 1.71429C6.81085 1.71429 8.28571 3.18915 8.28571 5H10.2857C10.2857 2.08458 7.91542 -0.285714 5 -0.285714V1.71429ZM8.28571 5C8.28571 6.81085 6.81085 8.28571 5 8.28571V10.2857C7.91542 10.2857 10.2857 7.91542 10.2857 5H8.28571Z",
    fill: "#E9EDF7",
    mask: "url(#path-1-inside-1_57890_49185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53213 3.46793C6.39265 3.32845 6.16654 3.32845 6.02706 3.46793L4.99991 4.49508L3.97273 3.46789C3.83325 3.32841 3.60713 3.32841 3.46765 3.46789C3.32817 3.60738 3.32817 3.83349 3.46765 3.97297L4.49483 5.00016L3.46765 6.02734C3.32817 6.16682 3.32817 6.39293 3.46765 6.53242C3.53737 6.60214 3.6288 6.63702 3.72019 6.63702C3.81158 6.63702 3.90297 6.60214 3.97273 6.53242L4.99991 5.50524L6.02709 6.53242C6.09682 6.60214 6.18825 6.63702 6.27963 6.63702C6.37102 6.63702 6.46241 6.60214 6.53217 6.53242C6.67166 6.39293 6.67166 6.16682 6.53217 6.02734L5.50499 5.00016L6.53217 3.97297C6.67162 3.83353 6.67162 3.60738 6.53213 3.46793Z",
    fill: "#E9EDF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57890_49185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseType1);
export default __webpack_public_path__ + "static/media/close_type1.64fde2f5d2dfbe334f986f056a011d7f.svg";
export { ForwardRef as ReactComponent };